import { Link } from 'react-router-dom';
import { BookOpen, Ruler, Wrench, ChevronRight } from 'lucide-react';

const RESOURCES = [
  {
    icon: BookOpen,
    title: 'Muzzle Brake FAQ',
    desc: 'Answers to the most common questions about our muzzle brakes and suppressors — compatibility, performance, legality, shipping, and more.',
    href: '/resources/faq',
    label: 'Read FAQ',
    badge: 'Popular',
  },
  {
    icon: Ruler,
    title: 'Measuring Guide',
    desc: 'How to measure your barrel correctly for a custom clamp-on muzzle brake. Getting this right ensures a perfect fit the first time.',
    href: '/resources/measuring',
    label: 'View Guide',
    badge: null,
  },
  {
    icon: Wrench,
    title: 'Installation Instructions',
    desc: 'Step-by-step instructions for installing your Witt Machine clamp-on muzzle brake safely and correctly.',
    href: '/resources/installation',
    label: 'Get Instructions',
    badge: null,
  },
];

export default function Resources() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] pt-16 lg:pt-20">
      <div className="bg-[#111111] border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <div className="section-divider" />
          <h1 data-testid="resources-heading" className="font-bebas text-5xl lg:text-6xl text-white tracking-wider mb-2">
            RESOURCES & SUPPORT
          </h1>
          <p className="font-inter text-sm text-zinc-500">Everything you need to get the most from your Witt Machine products</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-16">
          {RESOURCES.map(r => {
            const Icon = r.icon;
            return (
              <div
                key={r.href}
                data-testid={`resource-card-${r.title.toLowerCase().replace(/ /g, '-')}`}
                className="bg-[#111111] border border-white/10 hover:border-orange-500/40 p-8 group card-hover-lift"
              >
                {r.badge && (
                  <span className="inline-block font-bebas text-xs tracking-widest bg-orange-500 text-white px-2 py-1 mb-4">
                    {r.badge}
                  </span>
                )}
                <div className="w-12 h-12 bg-orange-500/10 border border-orange-500/20 flex items-center justify-center mb-5">
                  <Icon size={22} className="text-orange-500" />
                </div>
                <h2 className="font-bebas text-2xl text-white tracking-wider mb-3">{r.title}</h2>
                <p className="font-inter text-sm text-zinc-400 leading-relaxed mb-6">{r.desc}</p>
                <Link
                  to={r.href}
                  className="flex items-center gap-2 font-bebas text-sm tracking-widest text-orange-500 group-hover:text-white transition-colors"
                >
                  {r.label} <ChevronRight size={14} />
                </Link>
              </div>
            );
          })}
        </div>

        {/* Additional info */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="bg-[#111111] border border-white/10 p-8">
            <h2 className="font-bebas text-2xl text-white tracking-wider mb-4">NFA INFORMATION</h2>
            <p className="font-inter text-sm text-zinc-400 leading-relaxed mb-4">
              Suppressors and silencers are NFA (National Firearms Act) regulated items. They require:
            </p>
            <ul className="space-y-2 font-inter text-sm text-zinc-400">
              <li className="flex items-start gap-2"><span className="text-orange-500 mt-0.5">•</span>ATF Form 4 transfer through a licensed FFL/SOT dealer</li>
              <li className="flex items-start gap-2"><span className="text-orange-500 mt-0.5">•</span>Background check and ATF approval period</li>
              <li className="flex items-start gap-2"><span className="text-orange-500 mt-0.5">•</span>Must be a legal resident of a suppressor-legal state</li>
            </ul>
          </div>

          <div className="bg-[#111111] border border-white/10 p-8">
            <h2 className="font-bebas text-2xl text-white tracking-wider mb-4">CONTACT SUPPORT</h2>
            <p className="font-inter text-sm text-zinc-400 leading-relaxed mb-5">
              Can't find the answer you're looking for? Our team is here to help with any questions about products, orders, custom specs, or dealer partnerships.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 font-bebas text-sm tracking-widest bg-orange-500 hover:bg-orange-600 text-white px-5 py-3 transition-colors"
            >
              CONTACT US <ChevronRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
